module.exports = __webpack_public_path__ + "static/media/two.d22e81ac.png";